import * as types from '../actions/action-types';
import initialState from './initial-state';

export default function analyticsAppReducer(
    state = initialState.analytics,
    action
) {
    if (action.type === types.LOAD_ANALYTICS_APP_DATA_SUCCESS) {
        return {
            ...state,
            analyticsData: action.analytics,
            isAnalyticsDataLoadedSuccessfully: true
        };
    }

    if (action.type === types.LOAD_ANALYTICS_APP_DATA_ERROR) {
        return {
            ...state,
            analyticsData: {},
            isAnalyticsDataLoadedSuccessfully: false
        };
    }

    return state;
}
